// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"f62d0cdd","348":"09208522","571":"77523f51","924":"af1a840c"}[chunkId] + ".chunk.js";
};